import { Theme } from "@emotion/react";
import { CSSProperties } from "@styled-system/css";

export interface LogoProps {
  /**
   * Color of the Logo. Defaults to the primary color of the theme.
   */
  color?: keyof Theme["colors"] | "currentColor";
  width?: CSSProperties["width"];
  height?: CSSProperties["height"];
}

export const Logo = ({
  color = "primary",
  height = "1em",
  width = "1em",
}: LogoProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      version="1.1"
      viewBox="0 0 82.442 82.442"
    >
      <defs>
        <clipPath clipPathUnits="userSpaceOnUse">
          <path d="M0 400h550V0H0z"></path>
        </clipPath>
      </defs>
      <path
        fillOpacity="0"
        css={(theme) => ({
          stroke: color === "currentColor" ? color : theme.colors[color][500],
        })}
        strokeDasharray="none"
        strokeLinejoin="miter"
        strokeMiterlimit="4"
        strokeOpacity="1"
        strokeWidth="3.54"
        d="M3.21 1.77h76.023c.797 0 1.439.642 1.439 1.44v76.023c0 .797-.642 1.439-1.44 1.439H3.21a1.436 1.436 0 01-1.439-1.44V3.21c0-.797.642-1.439 1.44-1.439z"
        opacity="1"
      ></path>
      <path
        css={(theme) => ({
          fill: color === "currentColor" ? color : theme.colors[color][500],
        })}
        fillOpacity="1"
        fillRule="nonzero"
        stroke="none"
        strokeWidth="0.353"
        d="M27.908 53.561c.25.216.374.557.374 1.023v9.654c0 .864-.436 1.3-1.31 1.31l-8.219-.013c-.864 0-1.297-.433-1.297-1.297v-5.239c0-.066.017-.133.05-.2l-.012-.037-.038-.012v-4.166c-.008-.873.424-1.306 1.297-1.297l8.22-.013c.407.008.719.104.935.287m37.343-29.535c.017.881-.416 1.33-1.297 1.347l-8.207-.025c-.898 0-1.355-.44-1.372-1.322l-.013-5.251c.017-.881.474-1.322 1.372-1.322l8.257.025c.848.016 1.264.449 1.248 1.297l.012 5.251m-23.199 0l.012-5.251c.017-.881.474-1.322 1.372-1.322l8.17-.013c.898 0 1.343.445 1.335 1.335l-.013 5.251c.017.881-.424 1.322-1.322 1.322h-8.182c-.898 0-1.355-.44-1.372-1.322m-1.472 0c.008.89-.424 1.33-1.297 1.322h-8.207c-.873.009-1.314-.432-1.322-1.322l-.012-5.251c.016-.881.457-1.322 1.322-1.322h8.232c.864 0 1.288.44 1.272 1.322l.012 5.251M18.753 17.44l8.22.013c.873-.009 1.297.432 1.272 1.322l.012 5.251c.017.881-.407 1.322-1.272 1.322h-8.232c-.864 0-1.305-.44-1.322-1.322l-.012-5.251c.016-.881.461-1.326 1.334-1.335m46.51 28.126l.013 5.251c0 .865-.44 1.305-1.322 1.322l-45.2-.025c-.865 0-1.298-.432-1.298-1.297v-5.263c0-.084.017-.158.05-.225a6.681 6.681 0 01-.075-.524l.025-11c0-.15.013-.304.038-.462a1.085 1.085 0 01-.038-.287v-5.238c-.017-.882.408-1.322 1.272-1.322h8.232c.865 0 1.306.44 1.322 1.322v5.238c0 .1-.004.195-.012.287.008.158.012.312.012.461l-.025 10.428h26.118l.012-9.866H31.064c-.865 0-1.297-.433-1.297-1.297v-5.264c-.017-.881.407-1.322 1.272-1.322l32.877.025c.882-.017 1.33.416 1.347 1.297v5.264a.623.623 0 010 .174v.374l.013 11.388c-.009.125-.009.25 0 .374-.025.041-.03.104-.013.187m4.678 25.581c.798 0 1.201-.403 1.21-1.21l-.013-57.436c0-.715-.328-1.11-.985-1.185-.067 0-.142-.008-.225-.025l-57.399-.025c-.823.025-1.234.437-1.234 1.235v57.674c.091.64.503.952 1.234.935l57.412.037"
        opacity="1"
      ></path>
    </svg>
  );
};
